var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('v-main', [_vm.$apollo.loading && !_vm.isQuizCheck ? _c('v-layout', {
    staticStyle: {
      "height": "100vh"
    },
    attrs: {
      "justify-center": "",
      "align-center": "",
      "wrap": ""
    }
  }, [_c('v-progress-circular', {
    attrs: {
      "size": 70,
      "width": 7,
      "color": "primary",
      "indeterminate": ""
    }
  })], 1) : _vm._e(), !_vm.$apollo.loading ? [_c('core-warnings'), _c('core-toolbar'), _c('Drawer'), _c('div', {
    style: _vm.getUser && !_vm.getUser.onboarding ? 'padding-bottom: 60px' : '',
    attrs: {
      "id": "core-view"
    }
  }, [_c('router-view', {
    key: _vm.$route.path
  })], 1), _vm.getUser && !_vm.getUser.onboarding && !_vm.getIsSharingWhitelabels && !_vm.getIsInvite ? _c('core-platform-progress') : _vm._e(), _c('helper-suspended')] : _vm._e()], 2);

}
var staticRenderFns = []

export { render, staticRenderFns }